import { backendAxios } from "../Services/axios";
import { iPagination, iPaginationProps } from "../models/iPagination";

export default class SupportController {
  static async sendSupportForm(payload: any) {
    const response = await backendAxios.post("support-form", { payload });
    return response.data;
  }

  static async getCategoriesPaginated(
    params: iPaginationProps,
  ): Promise<iPagination<any>> {
    const url = "/supportfaqs/categories";

    const response = await backendAxios.get(url, {
      params,
    });
    return response.data;
  }
}
